import { Dropdown } from '@joor/design-system'
import styled from 'styled-components'

export const StyledDropdown = styled(Dropdown)`
  max-width: 440px;
  margin-bottom: 14px;
`
